import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import "components/pay/pay.css";
import { Payment } from "components";
import TypePayment from "components/pay/TypePayment";
import ValidateUser from "components/pay/ValidateUser";
import Selectgateway from "components/pay/Selectgateway";
import RenderBtnPayment from "components/pay/RenderBtnPayment";
import { ReactComponent as IconWhatsapp } from "assets/icons/whatsapp-icon-logo.svg";
import ScrollToTop from "common/scroll/ScrollToTop";
import {
  isDeprecatedPromoAccess,
  isPromoPaymentAccess,
} from "constants/payments";

const Payments = () => {
  const [user, setUser] = useState(null);
  const [mora, setMora] = useState(null);
  const [formConfig, setFormConfig] = useState({
    step: 1,
  });

  const location = useLocation();
  const hasDeprecatedPromoAccess = isDeprecatedPromoAccess(location);
  const showDiscountNotice = isPromoPaymentAccess(location);

  if (hasDeprecatedPromoAccess) {
    return <Navigate to="/pagos" replace />;
  }

  const showView = () => {
    switch (formConfig.step) {
      case 1:
        return (
          <ValidateUser
            setFormConfig={setFormConfig}
            setUser={setUser}
            setMora={setMora}
          />
        );
      case 2:
        return (
          <TypePayment
            setFormConfig={setFormConfig}
            user={user}
            setUser={setUser}
            mora={mora}
          />
        );
      case 3:
        return (
          <Payment
            user={user}
            setUser={setUser}
            mora={mora}
            setFormConfig={setFormConfig}
          />
        );
      case 4:
        return (
          <Selectgateway
            user={user}
            setUser={setUser}
            setFormConfig={setFormConfig}
          />
        );
      case 5:
        return <RenderBtnPayment user={user} setFormConfig={setFormConfig} />;

      default:
        break;
    }
  };

  return (
    <article className="container-payments-centered">
      <section className="form-container">
        <ScrollToTop step={formConfig.step} />
        <div className="separator mb-4">
          <hr className="line" />
          <p>Realiza tu pago</p>
          <hr className="line" />
        </div>
        <div className="container-pay">
          <img
            loading="lazy"
            src="/images/logo/logo-mercado-pago.svg"
            alt="mercado pago"
            width="150"
            height="50"
          />
          <img
            loading="lazy"
            src="/images/logo/pse-logo.png"
            alt="mercado pago"
            width="120"
            height="47"
          />
          {/* <img
          loading="lazy"
          src="/images/logo/openpay.svg"
          alt="mercado pago"
          width="180"
          height="50"
        /> */}
        </div>
        <a
          href="https://api.whatsapp.com/send?phone=573162971671&text=Buen%20d%C3%ADa%20%20%0ARequiero%20ayuda%20para%20realizar%20mis%C2%A0pagos"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-help-whatsapp"
        >
          <IconWhatsapp />
          ¿Necesitas ayuda? Chatea con nosotros
        </a>
        {showDiscountNotice && (
          <div className="discount-highlight" role="status">
            <span className="discount-highlight__icon" aria-hidden="true">
              🎉
            </span>
            <p className="discount-highlight__text">
              ¡Aprovecha este beneficio exclusivo! Descuento especial por pago
              total.
            </p>
            <span className="discount-highlight__icon" aria-hidden="true">
              🎉
            </span>
          </div>
        )}
        {/* <img
          src="images/button_obsequio.png"
          alt="haz tu pago total de la membresía y recibe un obsequio especial"
          className="mb-3 img-fluid"
        /> */}
        {showView()}
      </section>
    </article>
  );
};

export default Payments;
